/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function OrganizationSignupRequestFromJSON(json) {
    return OrganizationSignupRequestFromJSONTyped(json, false);
}
export function OrganizationSignupRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        firstName: !exists(json, 'first_name') ? undefined : json['first_name'],
        lastName: !exists(json, 'last_name') ? undefined : json['last_name'],
        tel: !exists(json, 'tel') ? undefined : json['tel'],
        companyName: !exists(json, 'company_name') ? undefined : json['company_name'],
        token: !exists(json, 'token') ? undefined : json['token'],
        organizationSubdomain: !exists(json, 'organization_subdomain') ? undefined : json['organization_subdomain'],
        password: !exists(json, 'password') ? undefined : json['password']
    };
}
export function OrganizationSignupRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        first_name: value.firstName,
        last_name: value.lastName,
        tel: value.tel,
        company_name: value.companyName,
        token: value.token,
        organization_subdomain: value.organizationSubdomain,
        password: value.password
    };
}
